import { Route } from 'react-router-dom';
import RewardsManagementPage from './pages/RewardsManagementPage';
import RedeemRewardsPage from './pages/RedeemRewardsPage';

export const RewardsRoutes = [
  <Route key="rewards" path="/dashboard/rewards" element={<RewardsManagementPage />} />,
  <Route key="redeem-rewards" path="/dashboard/redeem-rewards" element={<RedeemRewardsPage />} />
];